<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_WAREHOUSE_EFFICIENCY" />
    <div class="width-full flex-spacebetween" style="padding:3%">
        <div class="flex-align">
            <el-date-picker
                v-model="lineChart.queryParamsTime_pay"
                format="dd/MM/yyyy HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                :picker-options="$pickerOptions()"
                align="right"
                :start-placeholder="$t('BusinessPurchaseOrder.header.startData')"
                :end-placeholder="$t('BusinessPurchaseOrder.header.endData')"
                :default-time="Date.now() - 30 * 24 * 3600 * 1000"
            >
            </el-date-picker>
            <el-select v-model="lineChart.act" :placeholder="$t('chooseText')" style="margin-left:20px;">
                <el-option label="Recv3-MoveOut" value="Recv3-MoveOut" />
                <el-option label="Dir-MoveIn" value="Dir-MoveIn" />
                <el-option label="Dir-MoveInFBA" value="Dir-MoveInFBA" />
                <el-option label="Rep-MoveIn" value="Rep-MoveIn" />
            </el-select>
        </div>

        <el-radio-group v-model="lineChart.tabData">
            <el-radio-button label="0">day</el-radio-button>
            <el-radio-button label="1">week</el-radio-button>
            <el-radio-button label="2">month</el-radio-button>
        </el-radio-group>
    </div>
    <LineChart :chart-data="lineChart.lineChartData" />
    <LineChart :chart-data="lineChart.lineChartData2" />
  </div>
</template>
<script>
import { BUSINESS_WAREHOUSE_EFFICIENCY } from '@/utils/constants';
import LineChart from './LineChart1';
import { afterApi } from '@/api';
import moment from 'moment';
const echarts = require('echarts/lib/echarts');
export default {
  name: 'BusinessOrderTimelinessAverage',
  components: { LineChart },
  data() {
    return {
      BUSINESS_WAREHOUSE_EFFICIENCY,
      lineChart: {
        tabData: '0',
        lineChartData: {
          title: {
            text: 'Forklift Driver SkuQty Rank',
            textStyle: {
              align: 'center',
              color: '#082dc3',
              fontSize: 20,
            },
            top: '7%',
            left: '3%',
          },
          series: [
                {
                    name: 'Picker handles quantity',
                    type: 'bar',
                    stack: 'vistors',
                    barWidth: '60%',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#febb14' },
                        { offset: 0.5, color: '#ff8d13' },
                        { offset: 1, color: '#082dc3' }
                        ])
                    },
                    data: [],
                    animationDuration: 200,
                }
          ],
          xAxisData: [],
        },
        lineChartData2: {
          title: {
            text: 'Forklift Driver MoveCount Rank',
            textStyle: {
              align: 'center',
              color: '#082dc3',
              fontSize: 20,
            },
            top: '7%',
            left: '3%',
          },
          series: [
                {
                    name: 'Picker handles quantity',
                    type: 'bar',
                    stack: 'vistors',
                    barWidth: '60%',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#febb14' },
                        { offset: 0.5, color: '#ff8d13' },
                        { offset: 1, color: '#082dc3' }
                        ])
                    },
                    data: [],
                    animationDuration: 200,
                }
          ],
          xAxisData: [],
        },
        queryParamsTime_pay: [],
        creationStartDate: moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss'),
        creationEndDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        act: 'Recv3-MoveOut'
      }
    };
  },
  watch: {
    'lineChart.queryParamsTime_pay': {
      immediate: false,
      handler(v) {
        if (v) {
          this.lineChart.creationStartDate = (v || [])[0];
          this.lineChart.creationEndDate = (v || [])[1];
          this.getOrderReport();
        } else {
          this.lineChart.creationStartDate = moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss');
          this.lineChart.creationEndDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.getOrderReport();
        }
      }
    },
    'lineChart.tabData': {
      handler(v) {
        this.getOrderReport();
      }
    }
  },
  mounted() {
    this.getOrderReport();
  },
  methods: {
    // 根据年和周数转换为年月日
    getDateFromYearAndWeek(year, week) {
      const start = moment().year(year).isoWeek(week - 1).isoWeekday(0).format('YYYY-MM-DD');
      const end = moment().year(year).isoWeek(week).isoWeekday(0).format('YYYY-MM-DD');
      return `${start} to\n ${end}`;
    },

    // 清空 报表 操作
    emptyDataReport() {
      this.lineChart.lineChartData.series[0].data = [];
      this.lineChart.lineChartData.xAxisData = [];
    },
    // 获取报表
    getOrderReport() {
      const data = {
        creationStartDate: this.lineChart.creationStartDate,
        creationEndDate: this.lineChart.creationEndDate,
        reportType: this.lineChart.tabData,
        act: this.lineChart.act
      };
      afterApi.getSelectForkyKPI(data).then(res => {
        if (!res.length) {
          this.emptyDataReport();
        } else {
          this.emptyDataReport();
          const result = res.reduce((acc, cur) => {
            const index = acc.findIndex(item => item.userId === cur.userId);
            if (index === -1) {
                // eslint-disable-next-line no-prototype-builtins
                if (!cur.hasOwnProperty(cur.act)) {
                    cur[cur.act] = {
                        skuQty: cur.skuQty,
                        moveCount: cur.moveCount,
                    };
                }
                acc.push(cur);
            } else {
                // eslint-disable-next-line no-prototype-builtins
                if (!acc[index].hasOwnProperty(cur.act)) {
                    acc[index][cur.act] = {
                        skuQty: cur.skuQty,
                        moveCount: cur.moveCount,
                    };
                } else {
                    acc[index][cur.act]['skuQty'] += cur.skuQty;
                    acc[index][cur.act]['moveCount'] += cur.moveCount;
                }
                acc[index].skuQty += cur.skuQty;
                acc[index].moveCount += cur.moveCount;
            }
            return acc;
          }, []);
          const obj = {
            'Recv3-MoveOut': {skuQty: [], moveCount: [] },
            'Dir-MoveIn': {skuQty: [], moveCount: [] },
            'Dir-MoveInFBA': {skuQty: [], moveCount: [] },
            'Rep-MoveIn': {skuQty: [], moveCount: [] },
          };
          result.forEach(item => {
            if (item['Recv3-MoveOut']) {
                obj['Recv3-MoveOut'].skuQty.push(item['Recv3-MoveOut'].skuQty);
                obj['Recv3-MoveOut'].moveCount.push(item['Recv3-MoveOut'].moveCount);
            }
            if (item['Dir-MoveIn']) {
                obj['Dir-MoveIn'].skuQty.push(item['Dir-MoveIn'].skuQty);
                obj['Dir-MoveIn'].moveCount.push(item['Dir-MoveIn'].moveCount);
            }
            if (item['Dir-MoveInFBA']) {
                obj['Dir-MoveInFBA'].skuQty.push(item['Dir-MoveInFBA'].skuQty);
                obj['Dir-MoveInFBA'].moveCount.push(item['Dir-MoveInFBA'].moveCount);
            }
            if (item['Rep-MoveIn']) {
                obj['Rep-MoveIn'].skuQty.push(item['Rep-MoveIn'].skuQty);
                obj['Rep-MoveIn'].moveCount.push(item['Rep-MoveIn'].moveCount);
            }
          });
          this.lineChart.lineChartData.xAxisData = result.map(item => item.username);
          this.lineChart.lineChartData.series[0].data = obj['Recv3-MoveOut'].skuQty;

          this.lineChart.lineChartData2.xAxisData = result.map(item => item.username);
          this.lineChart.lineChartData2.series[0].data = obj['Recv3-MoveOut'].moveCount;
          console.log(1323, result);
        }
      });
    },
  },
};
</script>
